<template>
    <div class="c-product-data">
        <b-tabs fill>
            <b-tab active>
                <template slot="title">
                    {{Core.Definition.getDefinition('Général')}}
                </template>
                <b-row class="mt-3">
                    <b-col lg="6" md="7" sm="12">
                        <InputSelect
                                :ref="id"
                                :id="id"
                                :labelCols="4"
                                :options="Core.Product.typeOptions()"
                                :label="Core.Definition.getDefinition('Type de produit')"
                                v-model="dataValue.type"></InputSelect>
                    </b-col>
                </b-row>
                <hr/>
                <ProductDataStandard v-model="dataValue" v-if="!isVariable && Core.Value.decode(dataValue.type, 'select') === Core.Product.typeStandard"></ProductDataStandard>
                <ProductDataRecurringSubscription v-model="dataValue" v-if="!isVariable && Core.Value.decode(dataValue.type, 'select') === Core.Product.typeRecurringSubscription"></ProductDataRecurringSubscription>
                <ProductDataLimitedSubscription v-model="dataValue" v-if="!isVariable && Core.Value.decode(dataValue.type, 'select') === Core.Product.typeLimitedSubscription"></ProductDataLimitedSubscription>
            </b-tab>
            <b-tab>
                <template slot="title">
                    {{Core.Definition.getDefinition('Attributs')}}
                </template>

                <div class="mt-4" v-for="attribute, attributeIndex in dataAttributes">
                    <b-row class="mb-3">
                        <b-col>
                            <h5 class="text-muted">{{Core.Definition.getDefinition('Attribut')}} {{attributeIndex + 1}}</h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <InputText
                                    :label="Core.Definition.getDefinition('Nom')"
                                    v-model="dataAttributes[attributeIndex].name"></InputText>
                            <InputCheckbox
                                    v-if="isVariable"
                                    :label="Core.Definition.getDefinition('Utiliser comme variation')"
                                    v-model="dataAttributes[attributeIndex].isVariation"></InputCheckbox>
                            <b-button @click="trashAttribute(attributeIndex)" class="btn btn-danger btn-sm mb-3"><i class="fa fa-trash-o mr-2"></i>{{Core.Definition.getDefinition('Supprimer')}}</b-button>
                        </b-col>
                        <b-col>
                            <div>
                                {{Core.Definition.getDefinition('Valeurs de l\'attribut')}}
                                <b-button type="button" @click="addValue(attributeIndex)" class="btn btn-info btn-sm pull-right"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Valeur')}}</b-button>
                            </div>
                            <hr/>
                            <table width="100%">
                                <tr :key="valueIndex" v-for="value, valueIndex in dataAttributes[attributeIndex].values">
                                    <td>
                                        <b-form-input
                                                type="text"
                                                v-model="dataAttributes[attributeIndex].values[valueIndex].name"
                                                :placeholder="Core.Definition.getDefinition('Valeur')"></b-form-input>
                                    </td>
                                    <td>
                                        <b-button type="button" @click="trashValue(attributeIndex,valueIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></b-button>
                                    </td>
                                </tr>
                            </table>
                        </b-col>
                    </b-row>
                    <hr/>
                </div>

                <b-button type="button" @click="addAttribute" class="btn btn-info btn-sm mb-3 mt-3"><i class="fa fa-plus mr-1"></i>{{Core.Definition.getDefinition('Attribut')}}</b-button>


            </b-tab>
            <b-tab v-if="isVariable">
                <template slot="title">
                    {{Core.Definition.getDefinition('Variations')}}
                </template>

                <div v-if="hasVariations && variationAttributesReady" class="mt-4" v-for="variation, variationIndex in dataVariations">
                    <b-row class="mb-3">
                        <b-col>
                            <h5 class="text-muted">{{Core.Definition.getDefinition('Variation')}} {{variationIndex + 1}}</h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="3" v-if="variationAttribute.isVariation == true" v-for="variationAttribute, variationAttributeIndex in variationAttributes">
                            <b-form-group
                                    :label="variationAttribute.name">
                                <select :ref="'variationAttribute' + variationIndex.toString() + variationAttribute.key" @change="selectVariationAttribute(variationIndex, variationAttribute.key)" class="form-control">
                                    <option value=""></option>
                                    <option :selected="isVariationAttributeValue(variationIndex, variationAttribute.key, value.key)" v-for="value in variationAttribute.values" :value="value.key">{{value.name}}</option>
                                </select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <ProductDataStandard v-if="Core.Value.decode(dataValue.type, 'select') === Core.Product.typeVariableStandard" v-model="dataVariations[variationIndex]"></ProductDataStandard>
                            <ProductDataRecurringSubscription v-if="Core.Value.decode(dataValue.type, 'select') === Core.Product.typeVariableRecurringSubscription" v-model="dataVariations[variationIndex]"></ProductDataRecurringSubscription>
                            <ProductDataLimitedSubscription v-if="Core.Value.decode(dataValue.type, 'select') === Core.Product.typeVariableLimitedSubscription" v-model="dataVariations[variationIndex]"></ProductDataLimitedSubscription>
                        </b-col>
                    </b-row>
                    <b-button type="button" @click="trashVariation(variationIndex)" class="btn btn-danger btn-sm mb-3"><i class="fa fa-trash-o mr-2"></i>{{Core.Definition.getDefinition('Supprimer')}}</b-button>
                    <hr/>
                </div>

                <b-button v-if="hasVariations&&variationAttributesReady" type="button" @click="addVariation" class="btn btn-info btn-sm mb-3 mt-3"><i class="fa fa-plus mr-1"></i>{{Core.Definition.getDefinition('Variation')}}</b-button>

                <b-alert v-if="!hasVariations" class="mt-3" show variant="warning">
                    {{Core.Definition.getDefinition('Vous devez créer au moins 1 attribut variable. Sous l\'onglet Attributs, créer un attribut et cocher "Utiliser comme variation"')}}
                </b-alert>
                <b-alert v-if="hasVariations&&!variationAttributesReady" class="mt-3" show variant="warning">
                    {{Core.Definition.getDefinition('Attention, l\'un de vos attributs variables ne détient aucune valeur ou contient une valeur vide. Veuillez ajouter au moins une valeur à cet attribut avant de continuer.')}}
                </b-alert>

            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Alert from './Alert'
    import InputSelect from './InputSelect'
    import InputDate from './InputDate'
    import InputText from './InputText'
    import InputCurrency from './InputCurrency'
    import InputCC from './InputCC'
    import InputNumber from "./InputNumber"
    import InputCheckbox from './InputCheckbox'
    import ProductDataStandard from './ProductDataStandard'
    import ProductDataRecurringSubscription from './ProductDataRecurringSubscription'
    import ProductDataLimitedSubscription from './ProductDataLimitedSubscription'
    import InputMultiSelect from "./InputMultiSelect";
    
    export default {
        name: 'ProductData',
        components: {
            InputMultiSelect,
            InputCheckbox,
            InputCurrency,
            InputSelect,
            InputText,
            InputDate,
            InputCC,
            Alert,
            InputNumber,
            ProductDataRecurringSubscription,
            ProductDataStandard,
            ProductDataLimitedSubscription
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: function () {
                    return {
                        regularPrice: '0',
                        expirationPeriod: Core.Value.selectValue(Core.Product.periodMonth, Core.Product.periodOptions()),
                        expirationPeriodLength: '0',
                        periodLength: '0',
                        period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                        periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                        periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                        periodPaymentLength: '0',
                        bookingLimitInterval: Core.Value.selectValue(Core.Product.bookingLimitInterval, Core.Product.periodIntervalOptions()),
                        bookingLimitManagement: false,
                        bookingLimit: '0',
                        attributes: [],
                        variations: [],
                        isTaxable: true
                    }
                }
            },
            form: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
                this.dataAttributes = val.attributes
                this.dataVariations = val.variations
            },
            dataValue: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            },
            dataAttributes: {
                handler(val) {
                    this.dataValue.attributes = Core.Array.newArray(val)
                },
                deep: true
            },
            dataVariations: {
                handler(val) {
                    this.dataValue.variations = Core.Array.newArray(val)
                },
                deep: true
            }
        },
        mounted() {
            this.dataValue = Core.Array.newObject(this.value)
        },
        data: () => {
            return {
                Core: window.Core,
                dataAttributes: [],
                dataVariations: [],
                dataValue: {}
            }
        },
        computed: {
            variationAttributesReady() {
                for(let attribute in this.dataAttributes) {
                    if (this.dataAttributes[attribute].isVariation == true) {
                        if (this.dataAttributes[attribute].values.length === 0) {
                            return false
                        } else {
                            for(let value in this.dataAttributes[attribute].values) {
                                if (this.dataAttributes[attribute].values[value].name === undefined || this.dataAttributes[attribute].values[value].name === '') {
                                    return false
                                }
                            }
                        }
                    }
                }
                return true
            },
            hasVariations() {
                for(let attribute in this.dataAttributes) {
                    if (this.dataAttributes[attribute].isVariation == true) {
                        return true
                    }
                }
                return false
            },
            isVariable() {
                let variableTypes = [
                    Core.Product.typeVariableStandard,
                    Core.Product.typeVariableRecurringSubscription,
                    Core.Product.typeVariableLimitedSubscription
                ]
                for(let variableType in variableTypes)
                {
                    variableType = variableTypes[variableType]
                    if (variableType === Core.Value.decode(this.dataValue.type, 'select')) {
                        return true
                    }
                }
                return false
            },
            variationAttributes() {
                let variationAttributes = []
                for(let attribute in this.dataAttributes) {
                    attribute = this.dataAttributes[attribute]
                    variationAttributes.push(attribute)
                }
                return variationAttributes
            }
        },
        methods: {
            setOptions(options) {
            },
            getOptions() {
            },
            addAttribute() {
                this.dataAttributes.push(
                    {
                        name: '',
                        key: Core.Text.generateHash(),
                        values: []
                    }
                )
            },
            trashAttribute(attributeIndex) {
                this.dataAttributes.splice(attributeIndex, 1)
            },
            addValue(attributeIndex) {
                this.dataAttributes[attributeIndex].values.push(
                    {
                        name: '',
                        key: Core.Text.generateHash()
                    }
                )
            },
            trashValue(attributeIndex, valueIndex) {
                this.dataAttributes[attributeIndex].values.splice(valueIndex, 1)
            },
            addVariation() {
                if (this.hasVariations) {
                    this.dataVariations.push(
                        {
                            regularPrice: '0',
                            expirationPeriod: Core.Value.selectValue(Core.Product.periodMonth, Core.Product.periodOptions()),
                            expirationPeriodLength: '0',
                            bookingLimitManagement: false,
                            periodLength: '0',
                            period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                            periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                            periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                            periodPaymentLength: '0',
                            isTaxable: true,
                            bookingLimit: '0',
                            attributes: {},
                            variations: []
                        }
                    )
                }
            },
            trashVariation(variationIndex) {
                this.dataVariations.splice(variationIndex, 1)
            },
            selectVariationAttribute(variationIndex, attributeKey) {
                this.dataVariations[variationIndex].attributes[attributeKey] = this.$refs['variationAttribute' + variationIndex + attributeKey][0].value
                this.dataValue.variations = this.dataVariations
            },
            isVariationAttributeValue(variationIndex, attributeKey, value) {
                if (this.dataVariations[variationIndex].attributes[attributeKey] === value) {
                    return true
                }
                return false
            }
        }
    }
</script>
